// استدعاء المكتبات الخارجية من CDN
const loadExternalLibrary = (src) => {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

// تهيئة التأثيرات بعد تحميل الصفحة
document.addEventListener('DOMContentLoaded', async function() {
  try {
    // تحميل GSAP للحركات السلسة
    await loadExternalLibrary('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js');
    
    initializeEnhancedEffects();
    setupPerformanceOptimizations();
  } catch (error) {
    // Fallback إلى الكود الأساسي إذا فشل تحميل المكتبات
    console.warn('Failed to load external libraries, using fallback effects');
    initializeFallbackEffects();
  }
});

function initializeEnhancedEffects() {
  createOptimizedParticles();
  createAnimatedBackgroundText();
  setupGSAPAnimations();
}

function initializeFallbackEffects() {
  createStaticParticles();
  setupCSSAnimations(); // استخدام CSS animations كبديل
}

// تحسين الأداء وتقليل استهلاك الموارد
function setupPerformanceOptimizations() {
  // إيقاف الأنيميشن عند عدم ظهور الصفحة
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      // إيقاف GSAP animations
      if (window.gsap && window.gsap.globalTimeline) {
        gsap.globalTimeline.pause();
      }
      // إيقاف CSS animations
      document.body.style.animationPlayState = 'paused';
      document.querySelectorAll('.particle').forEach(el => {
        el.style.animationPlayState = 'paused';
      });
    } else {
      // استئناف GSAP animations
      if (window.gsap && window.gsap.globalTimeline) {
        gsap.globalTimeline.play();
      }
      // استئناف CSS animations
      document.body.style.animationPlayState = 'running';
      document.querySelectorAll('.particle').forEach(el => {
        el.style.animationPlayState = 'running';
      });
    }
  });

  // تحسين الأداء على الهواتف
  if ('ontouchstart' in window) {
    document.documentElement.style.setProperty('--particle-count', '25');
  }
}

// إعداد GSAP animations
function setupGSAPAnimations() {
  // تأثير النص الخلفي المتحرك
  gsap.to('.animated-bg-text', {
    scale: 1.1,
    duration: 6,
    repeat: -1,
    yoyo: true,
    ease: "sine.inOut",
    opacity: 0.2
  });

  // تأثير توهج للعناوين
  gsap.to('h1, h2, h3', {
    textShadow: '0 0 10px var(--neon-blue), 0 0 20px var(--hologram-blue)',
    duration: 3,
    repeat: -1,
    yoyo: true,
    ease: "power2.inOut"
  });

  // إضافة حركة GSAP للجسيمات
  animateParticlesWithGSAP();
}

// تحريك الجسيمات باستخدام GSAP مع الأنواع المختلفة
function animateParticlesWithGSAP() {
  const particles = document.querySelectorAll('.particle');
  
  particles.forEach((particle, index) => {
    // إعدادات عشوائية لكل جسيم بناءً على نوعه
    const particleType = particle.classList[1] || 'type-1';
    const settings = getParticleSettings(particleType);
    
    // حركة GSAP للجسيم مع تأثيرات متطورة - تتحرك للأعلى فقط
    gsap.to(particle, {
      y: `-=${150 + Math.random() * 100}`, // حركة تصاعدية فقط
      x: `+=${(Math.random() - 0.5) * 80}`, // حركة أفقية محدودة
      rotation: Math.random() * 180,
      scale: settings.scale.max,
      opacity: settings.opacity.max,
      duration: settings.duration,
      delay: Math.random() * 5,
      repeat: -1,
      ease: "power1.out",
      onStart: function() {
        // بدء التشغيل من مواقع في النصف السفلي
        gsap.set(particle, {
          opacity: settings.opacity.min,
          scale: settings.scale.min,
          rotation: 0
        });
      },
      onRepeat: function() {
        // إعادة تعيين إلى الموضع الأصلي في النصف السفلي
        gsap.set(particle, {
          opacity: settings.opacity.min,
          scale: settings.scale.min,
          y: 0,
          x: particle.dataset.originalLeft || particle.style.left
        });
      }
    });

    // تأثير الوميض للجسيمات
    gsap.to(particle, {
      boxShadow: settings.glow.max,
      duration: 1.5 + Math.random() * 1.5,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });
  });
}

// إعدادات الجسيمات بناءً على النوع
function getParticleSettings(type) {
  const settings = {
    'type-1': {
      scale: { min: 0.4, max: 1.3 },
      opacity: { min: 0.2, max: 0.9 },
      duration: 4 + Math.random() * 3,
      glow: {
        min: '0 0 5px var(--neon-blue), 0 0 10px rgba(0, 153, 255, 0.3)',
        max: '0 0 15px var(--neon-blue), 0 0 30px rgba(0, 153, 255, 0.7), 0 0 45px rgba(0, 153, 255, 0.4)'
      }
    },
    'type-2': {
      scale: { min: 0.3, max: 1.1 },
      opacity: { min: 0.3, max: 0.8 },
      duration: 3 + Math.random() * 2,
      glow: {
        min: '0 0 4px var(--cyan), 0 0 8px rgba(0, 255, 255, 0.3)',
        max: '0 0 12px var(--cyan), 0 0 24px rgba(0, 255, 255, 0.6), 0 0 36px rgba(0, 255, 255, 0.3)'
      }
    },
    'type-3': {
      scale: { min: 0.5, max: 1.6 },
      opacity: { min: 0.4, max: 0.8 },
      duration: 5 + Math.random() * 3,
      glow: {
        min: '0 0 6px var(--electric-blue), 0 0 12px rgba(0, 119, 204, 0.3)',
        max: '0 0 18px var(--electric-blue), 0 0 36px rgba(0, 119, 204, 0.6), 0 0 54px rgba(0, 119, 204, 0.3)'
      }
    },
    'type-4': {
      scale: { min: 0.2, max: 0.9 },
      opacity: { min: 0.5, max: 1.0 },
      duration: 2.5 + Math.random() * 2,
      glow: {
        min: '0 0 3px #ffffff, 0 0 6px rgba(255, 255, 255, 0.2)',
        max: '0 0 9px #ffffff, 0 0 18px rgba(255, 255, 255, 0.4), 0 0 27px rgba(255, 255, 255, 0.2)'
      }
    }
  };
  
  return settings[type] || settings['type-1'];
}

// إعداد CSS animations كبديل
function setupCSSAnimations() {
  // إضافة keyframes ديناميكيًا
  const style = document.createElement('style');
  style.textContent = `
    @keyframes textPulse {
      0%, 100% { 
        opacity: 0.1; 
        transform: translate(-50%, -50%) scale(1); 
      }
      50% { 
        opacity: 0.25; 
        transform: translate(-50%, -50%) scale(1.1); 
      }
    }
    
    @keyframes particleFloatUp {
      0% { 
        transform: translateY(0) translateX(0) scale(0.4);
        opacity: 0.2; 
      }
      50% { 
        opacity: 0.9; 
        transform: scale(1.3);
      }
      100% { 
        transform: translateY(-250px) translateX(20px) scale(0.4);
        opacity: 0.2; 
      }
    }
    
    @keyframes particleGlow {
      0%, 100% { 
        box-shadow: 0 0 5px currentColor, 0 0 10px rgba(0, 153, 255, 0.3);
      }
      50% { 
        box-shadow: 0 0 15px currentColor, 0 0 30px rgba(0, 153, 255, 0.6), 0 0 45px rgba(0, 153, 255, 0.3);
      }
    }
    
    .animated-bg-text {
      animation: textPulse 8s ease-in-out infinite;
    }
    
    .particle {
      animation: particleFloatUp 5s ease-in-out infinite, particleGlow 2s ease-in-out infinite;
    }
  `;
  document.head.appendChild(style);
}

function createOptimizedParticles() {
  const particleCount = window.innerWidth < 768 ? 30 : 60;
  const container = document.createElement('div');
  container.className = 'particles-container';
  container.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; pointer-events:none; z-index: var(--z-effects);';
  
  const particleTypes = ['type-1', 'type-2', 'type-3', 'type-4'];
  
  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    const typeIndex = Math.floor(Math.random() * particleTypes.length);
    const particleType = particleTypes[typeIndex];
    
    particle.className = `particle ${particleType}`;
    
    // توزيع الجسيمات من منتصف الشاشة إلى الأعلى
    const left = Math.random() * 100;
    
    // 70% من الجسيمات في النصف العلوي، 30% في النصف السفلي
    let top;
    if (Math.random() < 0.7) {
      // النصف العلوي: من 30% إلى 70%
      top = 30 + Math.random() * 40;
    } else {
      // النصف السفلي: من 70% إلى 90% (قريب من المنتصف)
      top = 70 + Math.random() * 20;
    }
    
    particle.style.left = left + 'vw';
    particle.style.top = top + 'vh';
    particle.dataset.originalLeft = left + 'vw';
    particle.dataset.originalTop = top + 'vh';
    
    // إعدادات بناءً على النوع
    const settings = getParticleSettings(particleType);
    
    // حجم الجسيم بناءً على النوع
    const baseSize = particleType === 'type-3' ? 4 : 
                    particleType === 'type-4' ? 1 : 3;
    const size = baseSize + Math.random() * 2;
    
    particle.style.width = size + 'px';
    particle.style.height = size + 'px';
    
    // لون الجسيم بناءً على النوع
    const colors = {
      'type-1': 'var(--neon-blue)',
      'type-2': 'var(--cyan)',
      'type-3': 'var(--electric-blue)',
      'type-4': '#ffffff'
    };
    
    particle.style.background = colors[particleType];
    particle.style.boxShadow = settings.glow.min;
    
    // جسيمات في الأعلى تكون أكثر وضوحاً
    if (top < 50) {
      particle.style.opacity = '0.8';
    }
    
    container.appendChild(particle);
  }
  
  document.body.appendChild(container);
}

function createAnimatedBackgroundText() {
  const bgText = document.createElement('div');
  bgText.className = 'animated-bg-text';
  bgText.textContent = '';
  bgText.style.opacity = '0.15';
  document.body.appendChild(bgText);
}

// الدوال الأساسية للنسخة الاحتياطية
function createStaticParticles() {
  const particleCount = window.innerWidth < 768 ? 25 : 45;
  const container = document.createElement('div');
  container.className = 'particles-container';
  container.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; pointer-events:none; z-index: var(--z-effects);';
  
  const particleTypes = ['type-1', 'type-2', 'type-3', 'type-4'];
  
  for (let i = 0; i < particleCount; i++) {
    const particle = document.createElement('div');
    const typeIndex = Math.floor(Math.random() * particleTypes.length);
    const particleType = particleTypes[typeIndex];
    
    particle.className = `particle ${particleType}`;
    
    const left = Math.random() * 100;
    
    // توزيع مكثف من المنتصف إلى الأعلى
    let top;
    if (Math.random() < 0.8) {
      // 80% من الجسيمات في النصف العلوي
      top = 30 + Math.random() * 50;
    } else {
      // 20% في النصف السفلي
      top = 70 + Math.random() * 20;
    }
    
    particle.style.left = left + 'vw';
    particle.style.top = top + 'vh';
    particle.style.animationDelay = Math.random() * 6 + 's';
    
    const baseSize = particleType === 'type-3' ? 4 : 
                    particleType === 'type-4' ? 1 : 3;
    const size = baseSize + Math.random() * 2;
    
    particle.style.width = size + 'px';
    particle.style.height = size + 'px';
    
    const colors = {
      'type-1': 'var(--neon-blue)',
      'type-2': 'var(--cyan)',
      'type-3': 'var(--electric-blue)',
      'type-4': '#ffffff'
    };
    
    particle.style.background = colors[particleType];
    
    container.appendChild(particle);
  }
  
  document.body.appendChild(container);
}

// تحسين إعادة الرسم عند تغيير حجم النافذة
window.addEventListener('resize', function() {
  const particlesContainer = document.querySelector('.particles-container');
  if (particlesContainer) {
    particlesContainer.remove();
    createOptimizedParticles();
    if (window.gsap) {
      animateParticlesWithGSAP();
    }
  }
});